export default "__VITE_ASSET__C8SdLY66__"